import Datapoint from 'owa-service/lib/contract/Datapoint';
import DatapointConsumer from 'owa-service/lib/contract/DatapointConsumer';
import logDatapointOperation from 'owa-service/lib/operation/logDatapointOperation';

export interface CaptureFeedbackDatapointProps {
    keys: string[];
    values: string[];
}

export function captureFeedbackDatapoint(props: CaptureFeedbackDatapointProps): Promise<boolean> {
    let feedbackLogDatapoint: Datapoint = {
        Id: 'CaptureFeedback',
        Consumers: DatapointConsumer.Analytics,
        Time: new Date(Date.now()).toString(),
        Keys: props.keys,
        Values: props.values,
    };

    return logDatapointOperation({ datapoints: [feedbackLogDatapoint] });
}
